import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 12361 20200"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#000;stroke-width:292.757}.fil0{fill:#2b2a29}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970278442064">
        <path
          d="M343 13545c262-263 688-263 950 0 262 262 262 687 0 950-262 262-688 262-950 0s-262-688 0-950zM2130 15333c263-263 688-263 950 0 262 262 262 687 0 949-263 263-688 263-950 0-262-262-262-687 0-949zM3918 17120c262-262 688-262 950 0s262 688 0 950-688 262-950 0c-263-262-263-688 0-950zM5705 18907c263-262 688-262 950 0 263 263 263 688 0 950-262 262-687 262-950 0-262-262-262-687 0-950zM12017 13545c-262-263-687-263-949 0-263 262-263 687 0 950 262 262 687 262 949 0 263-262 263-688 0-950zM10230 15333c-262-263-688-263-950 0-262 262-262 687 0 949 263 263 688 263 950 0 262-262 262-687 0-949zM8443 17120c-263-262-688-262-950 0s-262 688 0 950 687 262 950 0c262-262 262-688 0-950z"
          className="fill stroke1"
          style={{
            strokeWidth: 292.757,
          }}
        />
        <path
          d="M6655 18907c-262-262-687-262-950 0-262 263-262 688 0 950 263 262 688 262 950 0 263-262 263-687 0-950zM6180 7730c371 0 672 301 672 672s-301 671-672 671-671-301-671-671c0-371 300-672 671-672zM6180 10258c371 0 672 301 672 672 0 370-301 671-672 671s-671-301-671-671c0-371 300-672 671-672zM6180 12786c371 0 672 300 672 671s-301 672-672 672-671-301-671-672 300-671 671-671zM6180 15314c371 0 672 300 672 671s-301 672-672 672-671-301-671-672 300-671 671-671zM6180 146c371 0 672 301 672 672s-301 671-672 671-671-300-671-671 300-672 671-672zM6180 2674c371 0 672 301 672 672s-301 671-672 671-671-300-671-671 300-672 671-672zM6180 5202c371 0 672 301 672 672 0 370-301 671-672 671s-671-301-671-671c0-371 300-672 671-672z"
          className="fill stroke1"
          style={{
            strokeWidth: 292.757,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
